import { render, staticRenderFns } from "./EcgChartView.vue?vue&type=template&id=627c2f11&scoped=true&"
import script from "./EcgChartView.vue?vue&type=script&lang=js&"
export * from "./EcgChartView.vue?vue&type=script&lang=js&"
import style0 from "./EcgChartView.vue?vue&type=style&index=0&id=627c2f11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627c2f11",
  null
  
)

export default component.exports